// ABOUTME: The dealership choice rules of the catalogue, the cart and an offer, framework-free.
// ABOUTME: One dealership is used without asking; an offer gets one through Assign, by the users who may assign.

import type { SelectableDealerships } from '../types';

/** The roles that, with ASSIGN_DEALERSHIP, may assign a node to a dealership (server: canAssign). */
const COMPANY_ASSIGN_ROLES = [
    'COMPANY_SALES_DIRECTOR',
    'COMPANY_SALES_PERSON',
    'ALL_COMPANY',
    'PIM_SUPERADMIN',
];

/**
 * The picker opens when there are at least two options: several dealerships, or a dealership and
 * "None (company)". Without dealerships (a tenant that has none) "None" alone is no choice, so the
 * selection never shows, whatever the role.
 */
export const needsDealershipChoice = (selectable: SelectableDealerships): boolean =>
    selectable.dealerships.length + (selectable.allowNone ? 1 : 0) > 1;

/** Assign → Dealership needs ASSIGN_DEALERSHIP and a company role. */
export const canAssignDealership = (hasUserRole: (role: string) => boolean): boolean =>
    hasUserRole('ASSIGN_DEALERSHIP') && COMPANY_ASSIGN_ROLES.some(hasUserRole);

export type OfferDealershipAction =
    /** work in the offer's dealership */
    | { kind: 'use'; dealershipId: string }
    /** open Assign → Dealership on the offer before its catalogue */
    | { kind: 'ask' }
    /** leave the offer and the request dealership as they are */
    | { kind: 'keep' };

/**
 * What an offer needs before its catalogue opens, read on the offer alone: its `assignedDealership`
 * set means it works in that dealership; empty means it has none yet, and a user who may assign
 * assigns it first, everyone else opens it as it is.
 */
export const resolveOfferDealershipAction = (
    offerDealership: string | null | undefined,
    mayAssign: boolean,
): OfferDealershipAction => {
    if (offerDealership) return { kind: 'use', dealershipId: offerDealership };
    return mayAssign ? { kind: 'ask' } : { kind: 'keep' };
};
